import { ROLE_ALPHA_TESTER, ROLE_SECRETARY } from '@/config/constants';
import keycloak from './keycloak/init';

export const isAdmin = () => keycloak.hasRealmRole('admin');

export const isDoctor = () => !keycloak.hasRealmRole(ROLE_SECRETARY);
export const isSecretary = () => keycloak.hasRealmRole(ROLE_SECRETARY);

export const isAlphaSecretary = () =>
  keycloak.hasRealmRole(ROLE_ALPHA_TESTER) && keycloak.hasRealmRole(ROLE_SECRETARY);

export const isAlphaDoctor = () =>
  keycloak.hasRealmRole(ROLE_ALPHA_TESTER) && !keycloak.hasRealmRole(ROLE_SECRETARY);
